export enum IconDirections {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}
